import React from "react";
import Table from "../../widgets/tableCrm/Table";
import SelectInput from "../../widgets/SelectInput";

const TableSection = ({
  tables,
  titleFilter,
  searchCols,
  onCellClick,
  headCell,
}) => {
  // Colonne corso (escludendo la colonna "prov" dei labels riga)
  const courseCols = (headCell || []).filter((c) => c.id !== "prov");

  const generateRows = (data) => {
    return Object.keys(data).map((key) => {
      const row = { id: key, prov: key };
      courseCols.forEach((col) => {
        // dataKey = nome corrente del tag corso (chiave usata dal backend).
        // Fallback su label per retrocompatibilità.
        const cellKey = col.dataKey || col.label;
        row[col.id] = data[key]?.[cellKey]?.count || 0;
      });
      return row;
    });
  };

  // Funzione per calcolare il totale di tutti i valori nella tabella
  const calculateTotal = (data) => {
    if (!data) return 0;

    let total = 0;
    Object.keys(data).forEach((key) => {
      const row = data[key];
      if (row) {
        courseCols.forEach((col) => {
          const cellKey = col.dataKey || col.label;
          total += row[cellKey]?.count || 0;
        });
      }
    });

    return total;
  };

  return (
    <div style={{ flex: "1 ", marginBottom: "20px" }}>
      {tables
        .filter((table) => table.name.includes(titleFilter))
        .map((table, idx) => {
          const rows = table.data
            ? generateRows(table.data)
            : [{ id: "No Data", prov: 0 }];

          const total = calculateTotal(table.data);

          return (
            <div key={`${table.name}-${idx}`}>
              <div
                style={{
                  marginBottom: "10px",
                  fontWeight: "bold",
                  fontSize: "1.1em",
                  maxHeight: "30px",
                }}
              >
                {table.name}: TOTALE {total}
              </div>
              <Table
                headCells={headCell}
                searchCols={searchCols}
                rows={rows}
                noCerca
                leadsClick
                assenze={false}
                calendar={false}
                tableVersion={false}
                pdf={false}
                excel={false}
                mail={false}
                phone={false}
                onCellClick={(row, col) => {
                  // Traduci l'id colonna nel nome corrente del tag corso,
                  // perché i dati nel backend sono indicizzati per nome.
                  const colDef = courseCols.find((c) => c.id === col);
                  const colKey = colDef ? colDef.dataKey || colDef.label : col;
                  onCellClick(row, colKey, table);
                }}
              />
            </div>
          );
        })}
    </div>
  );
};

export default TableSection;
